const moment = require("moment");
const convert = require("convert-units");
const _ = require("lodash");

function formatDate(inputDate) {
  const date = moment(String(inputDate)).utc();
  if (!date.isValid()) {
    return "Invalid date";
  }
  return date.format("MMM Do");
}

const actionHrefs = {
  "finished-onboarding": (action) =>
    `/athlete-portal/profile?athlete=${action.clientId}&section=dashboard`,
  bodyPhotos: (action) =>
    `/athlete-portal/metrics/progress-photos?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  bodyWeight: (action) =>
    `/athlete-portal/metrics/bodyweight?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  bodyMeasurements: (action) =>
    `/athlete-portal/metrics/body-measurements?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  nutrients: (action) => `/athlete-portal/nutrition?athlete=${action.clientId}`,
  steps: (action) =>
    `/athlete-portal/metrics/step-count?date=${moment().format(
      "YYYYMMDD"
    )}&athlete=${action.clientId}`,
  sleep: (action) =>
    `/athlete-portal/metrics/sleep-time?date=${moment().format(
      "YYYYMMDD"
    )}&athlete=${action.clientId}`,
  hrv: (action) =>
    `/athlete-portal/metrics/hrv?date=${moment().format("YYYYMMDD")}&athlete=${
      action.clientId
    }`,
  waterIntake: (action) =>
    `/athlete-portal/metrics/water-intake?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  readiness: (action) =>
    `/athlete-portal/metrics/readiness-rate?date=${moment().format(
      "YYYYMMDD"
    )}&athlete=${action.clientId}`,
  "completed-accountabilities": (action) =>
    `/athlete-portal/metrics/accountability?date=${moment().format(
      "YYYYMMDD"
    )}&athlete=${action.clientId}`,
  "completed-check-in": (action) =>
    `/athlete-portal/metrics/check-in-summary?checkInDate=${moment(
      action.metadata?.checkInDate
    ).format("YYYY-MM-DD")}&athlete=${action.clientId}`,
  "completed-onboarding-check-in": (action) =>
    `/athlete-portal/profile/?athlete=${action.clientId}`,
  "swipe-completed-workout": (action) =>
    `/athlete-portal/calendar?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).utc().format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD")
    }&athlete=${action.clientId}&view=day`,
  sessionRPE: (action) =>
    `/athlete-portal/metrics/session-rpe?date=${moment().format(
      "YYYYMMDD"
    )}&athlete=${action.clientId}`,
  "uploaded-video-set": (action) => {
    const athlete = action.clientId;
    const dateYMD = action.metadata?.date
      ? moment(String(action.metadata?.date)).utc().format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    const base = `/athlete-portal/calendar?athlete=${athlete}&view=day&date=${dateYMD}`;
    const params = [];
    if (action.metadata?.threadId)
      params.push(`threadId=${action.metadata.threadId}`);
    if (action.metadata?.exerciseId)
      params.push(`exerciseToEdit=${action.metadata.exerciseId}`);
    if (action.metadata?.setIndex !== undefined)
      params.push(`setIndex=${action.metadata.setIndex}`);
    if (action.metadata?.videoIndex !== undefined)
      params.push(`videoIndex=${action.metadata.videoIndex}`);
    // Include video file params from videoData when available
    const { videoOriginal, uploaderId } = action.metadata?.videoData || {};
    if (videoOriginal) params.push(`originalId=${videoOriginal}`);
    if (uploaderId) params.push(`uploaderId=${uploaderId}`);
    // Open exercise-set-video modal when we have enough to target a specific video
    if (
      action.metadata?.exerciseId &&
      action.metadata?.setIndex !== undefined &&
      action.metadata?.videoIndex !== undefined
    ) {
      params.push("modal[type]=exercise-set-video");
    }
    return params.length ? `${base}&${params.join("&")}` : base;
  },
  "uploaded-video-set-video": (action) => {
    const athlete = action.clientId;
    const { date, videoData: { videoOriginal, mediaId, uploaderId } = {} } =
      action.metadata;
    const dateYMD = date
      ? moment(String(date)).utc().format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    const base = `/athlete-portal/calendar?athlete=${athlete}&view=day&date=${dateYMD}`;
    const params = ["modal[type]=exercise-set-video"];
    if (action.metadata?.threadId)
      params.push(`threadId=${action.metadata.threadId}`);
    if (action.metadata?.exerciseId)
      params.push(`exerciseToEdit=${action.metadata.exerciseId}`);
    if (action.metadata?.setIndex !== undefined)
      params.push(`setIndex=${action.metadata.setIndex}`);
    if (action.metadata?.videoIndex !== undefined)
      params.push(`videoIndex=${action.metadata.videoIndex}`);
    if (mediaId) params.push(`mediaId=${mediaId}`);
    if (videoOriginal) params.push(`originalId=${videoOriginal}`);
    if (uploaderId) params.push(`uploaderId=${uploaderId}`);
    return `${base}&${params.join("&")}`;
  },
  "commented-set": (action) =>
    `/athlete-portal/calendar?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).utc().format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD")
    }&athlete=${action.clientId}&view=day`,
  "commented-workout": (action) =>
    `/athlete-portal/calendar?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).utc().format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD")
    }&athlete=${action.clientId}&view=day`,
  "commented-check-in": (_action) => ``,
  "watched-check-in-video": (action) =>
    `/athlete-portal/metrics/check-in-summary?checkInDate=${moment(
      action.metadata?.checkInDate
    ).format("YYYY-MM-DD")}&athlete=${action.clientId}`,
  "added-exercise": (action) =>
    `/athlete-portal/calendar?athlete=${action.clientId}`,
  "deleted-exercise": (action) =>
    `/athlete-portal/calendar?athlete=${action.clientId}`,

  "added-calendar-program": (action) =>
    `/athlete-portal/calendar?athlete=${action.clientId}`,
  "moved-workout": (action) =>
    `/athlete-portal/calendar?athlete=${action.clientId}`,
  "meal-photos": (action) =>
    `/athlete-portal/metrics/meal-photos?startDate=${moment(
      action.metadata?.date
    )
      .startOf("month")
      .format("YYYYMMDD")}&endDate=${moment(action.metadata?.date)
      .endOf("month")
      .format("YYYYMMDD")}&athlete=${action.clientId}`,
  "meal-photos-update": (action) =>
    `/athlete-portal/metrics/meal-photos?startDate=${moment(
      action.metadata?.date
    )
      .startOf("month")
      .format("YYYYMMDD")}&endDate=${moment(action.metadata?.date)
      .endOf("month")
      .format("YYYYMMDD")}&athlete=${action.clientId}`,
  menstrualCycleTracking: (action) =>
    `/athlete-portal/metrics/female-cycle?date=${moment(
      action.metadata?.date
    ).format("YYYYMMDD")}&athlete=${action.clientId}`,
  "thread-comment": (action) => {
    const ctx = action.metadata?.threadContext;
    const athlete = action.clientId;
    const threadId = action.metadata?.threadId;
    const dateParam = action.metadata?.date
      ? moment(action.metadata.date).format("YYYYMMDD")
      : moment().format("YYYYMMDD");
    const dateYMD =
      action.metadata?.date &&
      moment(action.metadata.date).utc().format("YYYY-MM-DD");

    if (ctx === "exercise-video" && (dateYMD || threadId)) {
      const base = `/athlete-portal/calendar?athlete=${athlete}&view=day&date=${
        dateYMD || moment().format("YYYY-MM-DD")
      }`;
      const params = [];
      if (threadId) params.push(`threadId=${threadId}`);
      if (action.metadata?.exerciseId)
        params.push(`exerciseToEdit=${action.metadata.exerciseId}`);
      if (action.metadata?.setIndex !== undefined)
        params.push(`setIndex=${action.metadata.setIndex}`);
      if (action.metadata?.videoIndex !== undefined)
        params.push(`videoIndex=${action.metadata.videoIndex}`);
      const { videoOriginal, mediaId, uploaderId } =
        action.metadata?.videoData || {};
      if (videoOriginal) params.push(`originalId=${videoOriginal}`);
      if (mediaId) params.push(`mediaId=${mediaId}`);
      if (uploaderId) params.push(`uploaderId=${uploaderId}`);
      return params.length ? `${base}&${params.join("&")}` : base;
    }
    if (ctx === "body-photo") {
      let url = `/athlete-portal/metrics/progress-photos?date=${dateParam}&athlete=${athlete}`;
      if (threadId) url += `&threadId=${threadId}`;
      if (action.metadata?.photoType)
        url += `&photoType=${action.metadata.photoType}`;
      if (action.metadata?.dailyStatId)
        url += `&dailyStatId=${action.metadata.dailyStatId}`;
      return url;
    }
    if (ctx === "meal-photo") {
      const start = moment(action.metadata?.date || new Date())
        .startOf("month")
        .format("YYYYMMDD");
      const end = moment(action.metadata?.date || new Date())
        .endOf("month")
        .format("YYYYMMDD");
      let url = `/athlete-portal/metrics/meal-photos?startDate=${start}&endDate=${end}&athlete=${athlete}`;
      if (threadId) url += `&threadId=${threadId}`;
      if (action.metadata?.mealPhotoId)
        url += `&photoId=${action.metadata.mealPhotoId}`;
      return url;
    }
    if (ctx === "coach-video" && (threadId || action.metadata?.videoRecordId)) {
      let url = `/athlete-portal/profile?athlete=${athlete}&section=coachvideos`;
      if (threadId) url += `&threadId=${threadId}`;
      if (action.metadata?.videoRecordId)
        url += `&videoRecordId=${action.metadata.videoRecordId}`;
      return url;
    }
    if (threadId) {
      return `/athlete-portal/calendar?athlete=${athlete}&view=day&threadId=${threadId}`;
    }
    return `/athlete-portal/calendar?athlete=${athlete}&view=day`;
  },
  waterIntake: (action) =>
    `/athlete-portal/metrics/water-intake?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  bodyFatPercentage: (action) =>
    `/athlete-portal/metrics/body-fat?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
  restingHeartRate: (action) =>
    `/athlete-portal/metrics/resting-heart-rate?date=${
      action.metadata?.date
        ? moment(action.metadata?.date).format("YYYYMMDD")
        : moment().format("YYYYMMDD")
    }&athlete=${action.clientId}`,
};

const actionTextTypes = {
  "finished-onboarding": (action, _activeUser, t) => (
    <p>
      {t("activityItems.finishedOnboarding", {
        name: action.athleteName || action.clientName,
      })}
      {!action.isPress && !action.isPush && (
        <>
          {" "}
          {t("activityItems.buildProfile")}{" "}
          <a href={actionHrefs[action.actionType](action)}>
            {t("activityItems.here")}
          </a>
        </>
      )}
    </p>
  ),
  bodyPhotos: (action, _activeUser, t) => {
    const photosAmount = Object.keys(action.metadata?.bodyPhotos || {}).length;
    return (
      <p>
        {t("activityItems.bodyPhotos", {
          name: action.athleteName || action.clientName,
          count: photosAmount,
          date: formatDate(action.metadata?.date),
        })}
      </p>
    );
  },
  bodyWeight: (action, activeUser, t) => {
    const bodyWeight =
      activeUser.units === "imperial"
        ? convert(action.metadata?.bodyWeight).from("kg").to("lb")
        : action.metadata?.bodyWeight;
    const unit = activeUser.units === "imperial" ? "Lb" : "Kg";

    return (
      <p>
        {t("activityItems.bodyWeight", {
          name: action.athleteName || action.clientName,
          value: _.round(bodyWeight, 1),
          unit,
          date: formatDate(action.metadata?.date),
        })}
      </p>
    );
  },
  bodyMeasurements: (action, _activeUser, t) => (
    <p>
      {t("activityItems.bodyMeasurements", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  nutrients: (action, _activeUser, t) => (
    <p>
      {action.metadata?.date
        ? t("activityItems.nutrientsWithDate", {
            name: action.athleteName || action.clientName,
            date: formatDate(action.metadata?.date),
          })
        : t("activityItems.nutrientsNoDate", {
            name: action.athleteName || action.clientName,
          })}
    </p>
  ),
  steps: (action, _activeUser, t) => (
    <p>
      {t("activityItems.steps", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  sleep: (action, _activeUser, t) => (
    <p>
      {t("activityItems.sleep", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  hrv: (action, _activeUser, t) => (
    <p>
      {t("activityItems.hrv", {
        name: action.athleteName || action.clientName,
        hrv: action.metadata?.hrv,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  readiness: (action, _activeUser, t) => (
    <p>
      {t("activityItems.readiness", {
        name: action.athleteName || action.clientName,
        score:
          action.metadata?.readiness &&
          Object.values(action.metadata?.readiness)?.reduce(
            (prev, next) => prev + next
          ),
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "completed-accountabilities": (action, _activeUser, t) => (
    <p>
      {t("activityItems.completedAccountabilities", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "completed-check-in": (action, _activeUser, t) => (
    <p>
      {t("activityItems.completedCheckIn", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.checkInDate),
      })}
    </p>
  ),
  "completed-onboarding-check-in": (action, _activeUser, t) => (
    <p>
      {t("activityItems.completedOnboardingCheckIn", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata.checkInDate),
      })}
    </p>
  ),
  "swipe-completed-workout": (action, _activeUser, t) => (
    <p>
      {t("activityItems.swipeCompletedWorkout", {
        name: action.athleteName || action.clientName,
        date: action.metadata?.date ? formatDate(action.metadata?.date) : "",
      })}
    </p>
  ),
  sessionRPE: (action, _activeUser, t) => (
    <p>
      {t("activityItems.sessionRPE", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
        rpe: action.metadata?.sessionRPE || "",
      })}
    </p>
  ),
  "uploaded-video-set": (action, _activeUser, t) => (
    <p>
      {t("activityItems.uploadedVideoSet", {
        name: action.athleteName || action.clientName,
        date: action.metadata?.date ? formatDate(action.metadata?.date) : "",
      })}
    </p>
  ),
  "commented-set": (action, _activeUser, t) => (
    <p>
      {t("activityItems.commentedSet", {
        name: action.athleteName || action.clientName,
        date: action.metadata?.date ? formatDate(action.metadata?.date) : "",
      })}
    </p>
  ),
  "commented-workout": (action, _activeUser, t) => (
    <p>
      {t("activityItems.commentedWorkout", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "commented-check-in": (action, _activeUser, t) => (
    <p>
      {t("activityItems.commentedCheckIn", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "watched-check-in-video": (action, _activeUser, t) => (
    <p>
      {t("activityItems.watchedCheckInVideo", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.checkInDate),
      })}
    </p>
  ),
  "added-exercise": (action, _activeUser, t) => (
    <p>
      {t("activityItems.addedExercise", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "deleted-exercise": (action, _activeUser, t) => (
    <p>
      {t("activityItems.deletedExercise", {
        name: action.athleteName || action.clientName,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  "added-calendar-program": (action, _activeUser, t) =>
    action.metadata?.programName ? (
      <p>
        {action.metadata?.continuousAdd
          ? t("activityItems.startedProgramContinuous", {
              name: action.athleteName || action.clientName,
              programName: action.metadata?.programName,
            })
          : t("activityItems.startedProgramOnDate", {
              name: action.athleteName || action.clientName,
              programName: action.metadata?.programName,
              date: formatDate(action.metadata?.date),
            })}
      </p>
    ) : (
      <p>
        {t("activityItems.addedCalendarProgram", {
          name: action.athleteName || action.clientName,
          date: action.metadata?.date ? formatDate(action.metadata?.date) : "",
        })}
      </p>
    ),
  "moved-workout": (action, _activeUser, t) => (
    <p>
      {t("activityItems.movedWorkout", {
        name: action.athleteName || action.clientName,
        from: formatDate(action.metadata?.from)?.date,
        to: formatDate(action.metadata?.to),
      })}
    </p>
  ),
  "removed-coach": (action, _activeUser, t) => (
    <p>
      {t("activityItems.removedCoach", {
        name: action.athleteName || action.clientName,
      })}
    </p>
  ),
  "meal-photos": (action, _activeUser, t) => {
    const photosAmount = Object.keys(action.metadata?.mealPhotos || {}).length;
    return (
      <p>
        {t("activityItems.mealPhotos", {
          name: action.athleteName || action.clientName,
          count: photosAmount,
          date: formatDate(action.metadata?.date),
          mealType: action.metadata?.mealType,
        })}
      </p>
    );
  },
  "meal-photos-update": (action, _activeUser, t) => {
    const { changeType, mealType, updatedCount, originalDate, newDate } =
      action.metadata || {};
    const clientName = action.athleteName || action.clientName;

    if (changeType === "moved") {
      return (
        <p>
          {t("activityItems.mealPhotosUpdateMoved", {
            name: clientName,
            count: updatedCount,
            originalDate: formatDate(originalDate),
            newDate: formatDate(newDate),
            mealType,
          })}
        </p>
      );
    } else if (changeType === "timestamp-and-tags-updated") {
      return (
        <p>
          {t("activityItems.mealPhotosUpdateTimeTags", {
            name: clientName,
            count: updatedCount,
            date: formatDate(action.metadata?.date),
            mealType,
          })}
        </p>
      );
    } else if (changeType === "timestamp-updated") {
      return (
        <p>
          {t("activityItems.mealPhotosUpdateTime", {
            name: clientName,
            count: updatedCount,
            date: formatDate(action.metadata?.date),
            mealType,
          })}
        </p>
      );
    } else if (changeType === "tags-updated") {
      return (
        <p>
          {t("activityItems.mealPhotosUpdateTags", {
            name: clientName,
            count: updatedCount,
            date: formatDate(action.metadata?.date),
            mealType,
          })}
        </p>
      );
    } else {
      return (
        <p>
          {t("activityItems.mealPhotosUpdateOther", {
            name: clientName,
            count: updatedCount,
            date: formatDate(action.metadata?.date),
            mealType,
          })}
        </p>
      );
    }
  },
  menstrualCycleTracking: (action, _activeUser, t) => {
    const { date } = action.metadata || {};

    return (
      <p>
        {t("activityItems.menstrualCycleTracking", {
          name: action.athleteName || action.clientName,
          date: formatDate(date),
        })}
      </p>
    );
  },
  "client-feedback": (action, _activeUser, t) => (
    <p>
      {t("activityItems.clientFeedback", {
        name: action.athleteName || action.clientName,
      })}
    </p>
  ),
  "thread-comment": (action, _activeUser, t) => {
    const name = action.athleteName || action.clientName;
    const ctx = action.metadata?.threadContext;
    const dateStr = action.metadata?.date
      ? formatDate(action.metadata.date)
      : null;
    const photoTypeKey =
      action.metadata?.photoType &&
      ["front", "back", "side"].includes(action.metadata.photoType)
        ? action.metadata.photoType
        : null;
    const photoType = photoTypeKey
      ? t(`activityItems.threadCommentPhotoType.${photoTypeKey}`)
      : null;
    const mealType = action.metadata?.mealType || "";

    if (ctx === "exercise-video") {
      return (
        <p>
          {dateStr
            ? t("activityItems.threadCommentExerciseVideoWithDate", {
                name,
                date: dateStr,
              })
            : t("activityItems.threadCommentExerciseVideoNoDate", { name })}
        </p>
      );
    }
    if (ctx === "body-photo") {
      let bodyPhotoMsg;
      if (photoType && dateStr) {
        bodyPhotoMsg = t("activityItems.threadCommentBodyPhotoTypeAndDate", {
          name,
          photoType,
          date: dateStr,
        });
      } else if (photoType) {
        bodyPhotoMsg = t("activityItems.threadCommentBodyPhotoType", {
          name,
          photoType,
        });
      } else if (dateStr) {
        bodyPhotoMsg = t("activityItems.threadCommentBodyPhotoDate", {
          name,
          date: dateStr,
        });
      } else {
        bodyPhotoMsg = t("activityItems.threadCommentBodyPhoto", { name });
      }
      return <p>{bodyPhotoMsg}</p>;
    }
    if (ctx === "meal-photo") {
      let mealPhotoMsg;
      if (mealType && dateStr) {
        mealPhotoMsg = t(
          "activityItems.threadCommentMealPhotoMealTypeAndDate",
          {
            name,
            mealType,
            date: dateStr,
          }
        );
      } else if (mealType) {
        mealPhotoMsg = t("activityItems.threadCommentMealPhotoMealType", {
          name,
          mealType,
        });
      } else if (dateStr) {
        mealPhotoMsg = t("activityItems.threadCommentMealPhotoDate", {
          name,
          date: dateStr,
        });
      } else {
        mealPhotoMsg = t("activityItems.threadCommentMealPhoto", { name });
      }
      return <p>{mealPhotoMsg}</p>;
    }
    if (ctx === "coach-video") {
      return (
        <p>
          {dateStr
            ? t("activityItems.threadCommentCoachVideoWithDate", {
                name,
                date: dateStr,
              })
            : t("activityItems.threadCommentCoachVideoNoDate", { name })}
        </p>
      );
    }
    return (
      <p>
        {dateStr
          ? t("activityItems.threadCommentGenericWithDate", {
              name,
              date: dateStr,
            })
          : t("activityItems.threadCommentGenericNoDate", { name })}
      </p>
    );
  },
  waterIntake: (action, _activeUser, t) => {
    const name = action.athleteName || action.clientName;
    const date = formatDate(action.metadata?.date);
    const amount =
      action.metadata?.waterIntake != null
        ? _.round(Number(action.metadata.waterIntake), 1)
        : null;
    return (
      <p>
        {amount != null
          ? t("activityItems.waterIntakeWithAmount", {
              name,
              amount,
              date,
            })
          : t("activityItems.waterIntakeNoAmount", { name, date })}
      </p>
    );
  },
  waterIntake: (action) => (
    <p>
      {action.athleteName || action.clientName} logged water intake
      {action.metadata?.waterIntake != null
        ? ` of ${_.round(Number(action.metadata.waterIntake), 1)} L `
        : " "}
      for <b>{formatDate(action.metadata?.date)}</b>.
    </p>
  ),
  bodyFatPercentage: (action, activeUser, t) => (
    <p>
      {t("activityItems.bodyFatPercentage", {
        name: action.athleteName || action.clientName,
        value: action.metadata?.bodyFatPercentage,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
  restingHeartRate: (action, _activeUser, t) => (
    <p>
      {t("activityItems.restingHeartRate", {
        name: action.athleteName || action.clientName,
        value: action.metadata?.restingHeartRate,
        date: formatDate(action.metadata?.date),
      })}
    </p>
  ),
};

module.exports = {
  formatDate,
  actionHrefs,
  actionTextTypes,
};
